'use client';

import { ErrorNotFound } from '@libs/shared-ui';
import { usePathname, useSearchParams } from 'next/navigation';
import SearchPageError from '@app/plp/components/SearchPageError';

export default function NotFoundPage() {
    const pathname = usePathname();
    const isSearchPage = pathname?.startsWith('/search');
    const searchParams = useSearchParams();
    const searchTerm = searchParams?.get('q');

    return isSearchPage ? (
        <SearchPageError {...{ searchTerm }} />
    ) : (
        <ErrorNotFound />
    );
}
